<template>
    <div id="app">
        <share-head></share-head>
        <router-view/>
        <share-foot></share-foot>
        <share-top></share-top>
    </div>
</template>

<script>
import ShareHead from '@/components/share/Head.vue'
import ShareFoot from '@/components/share/Foot.vue'
import ShareTop from '@/components/share/Top.vue'

export default {
    components:{
        ShareFoot,
        ShareTop,
        ShareHead
    },
    watch: { 
        //每次路由变化，页面回到顶部
        '$route' () {
            document.documentElement.scrollTop = 0
        }
    },
}
</script>

